import {
  Add as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PersonIcon from '@mui/icons-material/Person';
import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { format } from "date-fns";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { TableSkeleton } from '../../../../components/TableSkeleton';
import CustomTextField from '../../../../components/Textfield';
import useCourses from '../../../../hooks/useCourses';
import useStudents from '../../../../hooks/useStudents';
import useCenterUsers from '../../../../hooks/useCenterUsers';
import { truncateFileName } from '../../../../utils/truncateFileName';
import CertificateDialog from './CertificateDialog';
import { toast } from 'react-toastify';

const StudentManagement = () => {

  const [deleteStudentId, setDeleteStudentId] = useState(null);
  const [certificateUrl, setCertificateUrl] = useState(null)
  const [student, setStudent] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const [isLoadingCertificates, setIsLoadingCertificates] = useState(false);

  // Pagination state (MUI TablePagination uses 0-based page)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //hooks
  const { courses, isCoursesLoading } = useCourses();
  const { centerUsers } = useCenterUsers(1, 1000);
  const { addStudent, isAddingStudent, isStudentsLoading, students, totalStudents, isUpdatingStudent, updateStudent, deleteStudent, isDeletingStudent, fetchCertificateByStudentId } = useStudents(page + 1, rowsPerPage);

  const { register, handleSubmit, watch, formState: { errors }, setValue, reset } = useForm();


  console.log({ studentId });

  // Dialog state
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleGetCertificate = async (studentId) => {
    setIsLoadingCertificates(true)
    setCertificateUrl(null);
    setStudentId(null)

    try {
      const data = await fetchCertificateByStudentId(studentId);
      console.log("Certificate Data:", data);
      setStudentId(studentId);
      console.log(">>>", data)
      setCertificateUrl(data.url);
    } catch (error) {
      console.error('Error in handleVerifyCertificate:', error);
      toast.error(error?.response?.data?.message || error?.response?.data?.error || "Something went wrong")

      // You might want to show an error message to the user here
    } finally {
      setIsLoadingCertificates(false)
    }
  };
  const handleOpenDialog = (student = null) => {

    if (student) {
      let courses = student?.courses?.map(course => course._id)?.[0] || [];
      let image = [student.image];

      console.log({ courses });
      reset({
        ...student,
        issued_on: format(new Date(student?.issued_on), "yyyy-MM-dd"),
        image,
        courses,
        centerName: student.centerName || 'THE ACCOUNTS EXPRESS',
        location: student.location || 'Malout',
        locationCode: student.locationCode || 'PB',
      });
      setIsEditing(true);
      setStudent({ ...student, image, courses: courses });
    } else {
      reset({
        name: "",
        fatherName: "",
        enrollment_no: "",
        serial_no: "",
        email: "",
        issued_on: "",
        image: null,
        courses: [],
        centerName: "THE ACCOUNTS EXPRESS",
        location: "Malout",
        locationCode: "PB",
      });
      setIsEditing(false)
      setStudent(null);
    }
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  // const handleStudentChange = (e) => {
  //   const { name, value } = e.target;
  //   setCurrentStudent(prev => ({ ...prev, [name]: value }));
  // };

  // const handleCoursesChange = (courseId) => {
  //   setCurrentStudent(prev => {
  //     const isSelected = prev.courses.includes(courseId);
  //     return {
  //       ...prev,
  //       courses: isSelected
  //         ? prev.courses.filter(id => id !== courseId)
  //         : [...prev.courses, courseId]
  //     };
  //   });
  // };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   console.log({ file });
  //   if (file) {
  //     // In a real app, you'd handle the file upload to a server
  //     setCurrentStudent(prev => ({ ...prev, image: file }));
  //   }
  // };

  const handleSaveStudent = async (values) => {

    console.log({ values });

    const formData = new FormData();

    // Append string fields
    formData.append("name", values.name);
    formData.append("fatherName", values.fatherName);
    formData.append("enrollment_no", values.enrollment_no);
    formData.append("serial_no", values.serial_no);
    formData.append("email", values.email);
    formData.append("issued_on", values.issued_on);
    formData.append("marks", JSON.stringify(values.marks));
    formData.append("centerName", values.centerName || "THE ACCOUNTS EXPRESS");
    formData.append("location", values.location || "Malout");
    formData.append("locationCode", values.locationCode || "PB");


    // Append array fields (e.g., courses)
    // values.courses.forEach((courseId, index) => {
    //   formData.append(`courses[${index}]`, courseId);
    // });


    formData.append("courses", values.courses);


    if (isEditing && student) {

      // Append image (assuming `values.image` contains the file)
      if (values.image && values?.image?.[0]?.name !== student?.image?.[0]?.name) {
        formData.append("image", values.image[0]);
      }

      formData.append("_id", student._id);

      await updateStudent(formData);
    } else {

      if (values.image && values?.image?.[0]) {
        formData.append("image", values.image[0]);
      }

      // setStudents(prev => [...prev, currentStudent]);
      await addStudent(formData);

    }
    handleCloseDialog();
  };

  const handleRemoveImage = () => {
    // Clear the image field
    setValue("image", []);
  };

  // const handleDeleteStudent = (studentId) => {
  //   setStudents(prev => prev.filter(student => student.id !== studentId));
  // };

  console.log({ i: watch("courses"), courses });
  console.log({ student });

  const handleDeleteStudent = async () => {
    await deleteStudent(deleteStudentId);
    setDeleteStudentId(null)
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const selectedCourses = watch("courses") || [];  // Get selected course IDs

  // Filter subjects for the selected courses
  const coursesData = courses
    .filter((course) => selectedCourses.includes(course._id)) // Filter courses based on selected IDs



  console.log({ selectedCourses, coursesData });


  if (isStudentsLoading) {
    return <TableSkeleton />;
  }


  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 2 },
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
          Students List
        </Typography>
        <Button
          variant="contained"
          sx={{
            background: "#454751d1",
            fontSize: { xs: 14, sm: 15 },
            whiteSpace: "nowrap",
            flexShrink: 0,
            width: { xs: "100%", sm: "auto" },
            py: { xs: 1, sm: 1.5 },
          }}
          startIcon={<AddIcon />}
          onClick={() => handleOpenDialog()}
        >
          Add Student
        </Button>
      </Box>

      {/* Students Table */}
      <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px' }}>
        {/* Force a horizontal scrollbar if content overflows */}
        <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Student Name</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Father's Name</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Enrollment No</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Email</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Issued On</TableCell>
                <TableCell>Courses</TableCell>
                <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {students?.length > 0 ? (
                students.map((student) => (
                  <TableRow key={student._id} sx={{ "& td": { fontSize: "14px" } }}>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ mr: 1, width: 32, height: 32 }}>
                          {!!student?.image?.url ? (
                            <img
                              src={student?.image?.url || ""}
                              alt={student.name}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <PersonIcon />
                          )}
                        </Avatar>
                        {student.name}
                      </Box>
                    </TableCell>
                    <TableCell>{student.fatherName}</TableCell>
                    <TableCell>{student.enrollment_no}</TableCell>
                    <TableCell>{student.email}</TableCell>
                    <TableCell>{new Date(student.issued_on).toLocaleDateString()}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {student?.courses?.map((course) => (
                          <Chip
                            key={course._id}
                            label={<Typography variant="h6">{course.title}</Typography>}
                            size="small"
                            color="success"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                      <IconButton
                        color="primary"
                        onClick={() => handleOpenDialog(student)}
                        size="small"
                      >
                        <EditIcon fontSize="large" />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => setDeleteStudentId(student?._id)}
                        size="small"
                      >
                        <DeleteIcon fontSize="large" />
                      </IconButton>
                      <IconButton
                        color="success"
                        onClick={() => handleGetCertificate(student?._id)}
                        size="small"
                      >
                        <InsertDriveFileIcon fontSize="large" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="h6">No students found. Add a student to get started.</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={totalStudents}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            px: 2,
            py: 0.5,
            '& .MuiTablePagination-toolbar': {
              minHeight: 52,
              flexWrap: 'wrap',
              gap: 1,
            },
            '& .MuiTablePagination-selectLabel': {
              fontSize: '14px',
              fontWeight: 500,
              m: 0,
            },
            '& .MuiTablePagination-displayedRows': {
              fontSize: '14px',
              fontWeight: 500,
              m: 0,
            },
            '& .MuiTablePagination-select': {
              fontSize: '14px',
              fontWeight: 500,
            },
            '& .MuiTablePagination-actions': {
              ml: 1,
              '& .MuiIconButton-root': {
                p: '6px',
                borderRadius: '8px',
                border: '1px solid',
                borderColor: 'divider',
                mx: 0.3,
                '&:not(:disabled):hover': {
                  backgroundColor: 'action.hover',
                },
                '& svg': {
                  fontSize: '18px',
                },
              },
            },
          }}
        />
      </Paper>

      {/* Student Dialog */}

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <form onSubmit={handleSubmit(handleSaveStudent)}>
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {isEditing ? 'Edit Student' : 'Add New Student'}
              <IconButton edge="end" color="inherit" onClick={handleCloseDialog} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ maxHeight: '70vh' }}>
            <Grid container spacing={2} >
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("name", { required: "Student Name is required" })}
                  fullWidth
                  label="Student Name*"
                  error={!!errors.name} // Shows error state if validation fails
                  helperText={errors.name?.message} // Display custom error message
                />

              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }} >
                <CustomTextField
                  {...register("fatherName", { required: "Father Name is required" })}
                  fullWidth
                  label="Father's Name*"
                  error={!!errors.fatherName} // Shows error state if validation fails
                  helperText={errors.fatherName?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("enrollment_no", { required: "Enrollment No is required" })}
                  fullWidth
                  label="Enrollment No*"
                  error={!!errors.enrollment_no} // Shows error state if validation fails
                  helperText={errors.enrollment_no?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("serial_no", { required: "Serial No is required" })}
                  fullWidth
                  label="Serial No*"
                  error={!!errors.serial_no} // Shows error state if validation fails
                  helperText={errors.serial_no?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("email", { required: "Serial No is required" })}
                  fullWidth
                  label="Email*"
                  type="email"
                  error={!!errors.email} // Shows error state if validation fails
                  helperText={errors.email?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("issued_on", { required: "Issued On Date is required" })}
                  fullWidth
                  label="Issued On*"
                  name="issued_on"
                  type="date"
                  InputLabelProps={{
                    shrink: true,  // Ensures the label stays above the input for date fields
                  }}
                  error={!!errors.issued_on}  // If there's an error, show the error state
                  helperText={errors.issued_on?.message}  // Show the validation error message
                />
              </Grid>

              {/* Center Name */}
              <Grid item size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth error={!!errors.centerName}>
                  <InputLabel sx={{ fontSize: 14 }}>Center Name *</InputLabel>
                  <Select
                    label="Center Name *"
                    defaultValue="THE ACCOUNTS EXPRESS"
                    {...register("centerName", { required: "Center Name is required" })}
                    value={watch("centerName") || "THE ACCOUNTS EXPRESS"}
                    onChange={(e) => setValue("centerName", e.target.value, { shouldValidate: true })}
                    sx={{ fontSize: 14, borderRadius: '8px' }}
                  >
                    <MenuItem value="THE ACCOUNTS EXPRESS" sx={{ fontSize: 14 }}>
                      THE ACCOUNTS EXPRESS
                    </MenuItem>
                    {centerUsers
                      .filter((u) => u.centerName)
                      .map((u) => (
                        <MenuItem key={u._id} value={u.centerName} sx={{ fontSize: 14 }}>
                          {u.centerName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.centerName && (
                    <Typography fontSize={11} color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.centerName.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Location fields — always visible */}
              <Grid item size={{ xs: 12, sm: 4 }}>
                <CustomTextField
                  {...register("location", { required: "Location is required" })}
                  fullWidth
                  label="Center Location (City)*"
                  placeholder="e.g. Malout"
                  error={!!errors.location}
                  helperText={errors.location?.message}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 2 }}>
                <CustomTextField
                  {...register("locationCode", { required: "State code is required" })}
                  fullWidth
                  label="State Code*"
                  placeholder="e.g. PB"
                  error={!!errors.locationCode}
                  helperText={errors.locationCode?.message}
                  inputProps={{ maxLength: 4, style: { textTransform: 'uppercase' } }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 6 }}>
                <input
                  type="file"
                  id="image"
                  accept="image/*"
                  {...register("image", {
                    required: "Student photo is required",
                    validate: (v) => (v && v.length > 0) || "Please upload a photo",
                  })}
                  style={{ display: "none" }}
                />

                <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} gap={2} mb={1}>
                  <Button
                    variant="contained"
                    component="span"
                    onClick={() => document.getElementById("image")?.click()}
                    disabled={!!watch("image")?.[0]?.name}
                    sx={{ fontSize: 15 }}
                  >
                    Choose Profile Picture
                  </Button>

                  {watch("image")?.[0]?.name && (
                    <Chip
                      label={
                        <Typography fontSize={14}>
                          {truncateFileName(watch("image")?.[0]?.name)}
                        </Typography>
                      }
                      size="small"
                      color="primary"
                      variant="outlined"
                      onDelete={handleRemoveImage}
                      sx={{ maxWidth: '100%' }}
                    />
                  )}
                </Box>

                {errors.image && (
                  <Typography variant="caption" color="error" ml={1.5} fontSize={12}>
                    {errors.image.message}
                  </Typography>
                )}
              </Grid>


              {/* Courses Selection */}
              <Grid item size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth variant="outlined" error={!!errors.courses} required>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      fontSize: 15,
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -9px) scale(0.75)',
                        backgroundColor: 'white',
                        padding: '0 4px',
                      },
                    }}
                  >
                    Select Course
                  </InputLabel>

                  {isCoursesLoading ? (
                    <CircularProgress sx={{ mt: 2 }} />
                  ) : courses?.length > 0 ? (
                    <Select
                      label="Select Course"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      defaultValue={student?.courses || ""}
                      error={!!errors.courses} // <- Important
                      {...register("courses", {
                        required: "Please select a course",
                      })}
                      sx={{
                        height: '56px',
                        fontSize: 14,
                        '& .MuiSelect-select': {
                          padding: '14px',
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>courses</em>
                      </MenuItem>
                      {courses.map((course) => (
                        <MenuItem key={course._id} value={course._id}>
                          {course.title}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                      No courses available. Please add courses first.
                    </Typography>
                  )}

                  {errors.courses && (
                    <Typography variant="body2" color="error" sx={{ mt: 1, fontSize: 12, ml: 1.5 }}>
                      {errors.courses.message}
                    </Typography>
                  )}
                </FormControl>

              </Grid>

              {coursesData?.length > 0 && <Grid item size={{ xs: 12 }}>
                <Typography variant="h6" fontSize={18} fontWeight={600} textAlign={"center"} sx={{ borderBottom: "1px solid grey", mt: 2 }} >Subjects and Marks</Typography>



                {coursesData?.map((course, index) =>
                  <Stack key={course._id}>
                    <Typography variant="h6" fontSize={15} sx={{ mb: 1, mt: 2 }} >{course.title}</Typography>
                    <TableContainer component={Paper} variant='outlined'>
                      <Table >
                        <TableHead>
                          <TableRow sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}>
                            <TableCell>Subject</TableCell>
                            <TableCell>Full Marks</TableCell>
                            <TableCell>Obtain Marks</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {course?.subjects?.map((subject) => (
                            <TableRow key={subject._id} sx={{ "& td": { fontSize: "14px" } }}>
                              <TableCell>{subject.name}</TableCell>
                              <TableCell>{subject.marks}</TableCell>
                              <TableCell>
                                <CustomTextField
                                  {...register(`marks.${course._id}.${subject._id}`)} // Use dynamic name for each subject's marks
                                  size="small"
                                  type="number"
                                  fullWidth
                                  variant="outlined"
                                  InputProps={{ inputProps: { min: 0, max: subject?.marks || 100 } }}
                                  defaultValue={0}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Stack>)}

              </Grid>}

            </Grid>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} sx={{ fontSize: 14, color: "#454751d1" }} >Cancel</Button>
            <Button
              sx={{ fontSize: 14, background: "#454751d1" }}
              type='submit'
              variant="contained"
              disabled={isAddingStudent || isUpdatingStudent}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Student Dialog */}
      <Dialog open={!!deleteStudentId} onClose={() => setDeleteStudentId(null)} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Delete Student
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDeleteStudentId(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 3 }}>
          Are you sure you want to delete this student?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteStudentId(null)}
            sx={{ fontSize: 13, color: "#454751d1" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteStudent}
            sx={{ fontSize: 13 }}
            variant="contained"
            disabled={isDeletingStudent}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <CertificateDialog
        open={!!studentId}
        onClose={() => {
          setStudentId(null);
          setCertificateUrl(null);
        }}
        certificateUrl={certificateUrl}
        isLoadingCertificates={isLoadingCertificates}
        studentId={studentId}
      />

    </Box>
  );
};

export default StudentManagement;